import { useEffect } from "react";
import { Modal, Button, Form, Input, Radio } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { addmedicine, deletemedicine, updatemedicine } from "../../services/doctor/medicine/medicine";
import { useMessageApi } from "../../services/message api/MessageProvider";
import { addFee, updateFee } from "../../services/doctor/fees/fees";

export default function FeeModal({ show, onHide, refresh, type, record,isedit }) {
  const [form] = Form.useForm();
  const messageApi = useMessageApi();

useEffect(() => {
  if (isedit && record) {
    form.setFieldsValue({
      fee_name: record.fee_name ?? "",
      fee_amount: record.fee_amount ?? "",
      fee_type: record.fee_type ?? "",
    });
  } else {
    form.resetFields();
  }
}, [isedit, record, form]);


  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const formData = { ...values };

      let result;
      if (isedit) {
        result = await updateFee(record.id, formData);
      } else {
        result = await addFee(formData);
      }

      if (result?.success) {
        messageApi.open({
          type: "success",
          content: isedit
            ? "Fee updated successfully!"
            : "Fee added successfully!",
        });

        onHide();
        refresh("fees");
      } else {
        messageApi.error(result.error || "Something went wrong");
      }
    } catch (error) {
      messageApi.error(error.message || "Submission failed");
      console.log("catch error:", error);
    }
  };

  return (
    <Modal
      title={isedit ? "Edit Fee" : "Add Fee"}
      open={show}
      onCancel={onHide}
      maskClosable={false}
      keyboard={false}
      centered
      width={600}
      className="vitals-modal"
      closeIcon={<CloseOutlined />}
      footer={[
        <Button key="cancel" onClick={() => onHide(null)}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          {isedit ? "Save Changes" : "Add"}
        </Button>,
      ]}
    >
      <Form layout="vertical" form={form}>

        {/* ✅ Fee Name */}
        <Form.Item
          label="Fee Name"
          name="fee_name"
          rules={[{ required: true, message: "Please enter fee name" }]}
        >
          <Input placeholder="Enter fee name (e.g. X-ray)" />
        </Form.Item>

        {/* ✅ Fee Amount (Number) */}
        <Form.Item
          label="Fee Amount"
          name="fee_amount"
          rules={[{ required: true, message: "Please enter fee amount" }]}
        >
          <Input
            type="number"
            min={0}
            placeholder="Enter fee amount"
          />
        </Form.Item>

        {/* ✅ Fee Type (Radio Button) */}
        <Form.Item
          label="Fee Type"
          name="fee_type"
          rules={[{ required: true, message: "Please select fee type" }]}
        >
          <Radio.Group>
            <Radio value="Service">Service</Radio>
            <Radio value="Consumable">Consumable</Radio>
          </Radio.Group>
        </Form.Item>

      </Form>
    </Modal>
  );
}

FeeModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  refresh: PropTypes.func,
  type: PropTypes.string,
  record: PropTypes.object,
    isedit: PropTypes.bool,
};
